import React from 'react';
import { connect } from 'react-redux';
import { actionCreators } from './store';
import { actionCreators as courseActionCreators } from 'courseProjectStore';
import history from 'common/history'
import { Link } from 'react-router-dom';
import './index.css'
import Header from 'component/mobile_header'
import Video from './components/video'
import VideoTab from './components/videoTab'
import { getFinishedCourseLock } from '../course_project/store/actionCreators';
import axios from 'axios';
import { userApi } from 'common/request';
import { Button, Modal } from 'antd-mobile';

class LabRoom extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      courseid:'',
      sid:'',
      modalError: false,
      modalSuccess: false,
      address: ''
    }
  }

  componentWillMount(){
    // document.title = '实验视频';
    const {getSubjectInfo,getQuestionList,getUserQuestionList,getOtherQuestionList, getFinishedCourse, user_id} = this.props;
    let str = this.props.match.params.id
    this.initPage(str)
  }

  initPage (str) {
    const {getSubjectInfo,getCourseInfo, getQuestionList,
      getUserQuestionList,getOtherQuestionList, getFinishedCourseLock,
      getFinishedCourse, getFinishedPlaytime, getFiuser_id, user_id} = this.props;
    let newJson = this.getJson(str)
    if(newJson[0]&&newJson[0].courseid&&newJson[0].sid){
      let courseid = newJson[0].courseid;
      let sid = newJson[0].sid;
      this.setState({
         courseid,
         sid
      });
      getCourseInfo(courseid)
      getSubjectInfo(courseid,sid);
      //getQuestionList(courseid)
      getUserQuestionList(courseid);
      getOtherQuestionList(courseid);
      // 获取已完成课程列表
      if(JSON.parse(localStorage.getItem('userinfo')) !== null) {
        let get_user_id = JSON.parse(localStorage.getItem('userinfo')).user_id;
        getFinishedCourse(courseid, user_id.length? user_id: get_user_id);
        getFinishedCourseLock(courseid, JSON.parse(localStorage.getItem('userinfo')).account);
        getFinishedPlaytime(courseid, get_user_id, sid);
      }
      this.props.recordCreate({course_id: String(courseid), course_subject_id: String(sid), type: 'learn'});
      // this.props.recordCreate({course_id: String(courseid), course_subject_id: String(sid), type: 'learned'});
    }else{
      window.history.go(-1)
    }
  }

  componentWillReceiveProps (newProps) {
    console.log('componentDidUpdate', newProps)
    if (newProps.match.params.id == this.props.match.params.id) return
    let str = newProps.match.params.id
    console.log('componentDidUpdate  ffffffffffffffffff', str)
    this.initPage(str)
  }  

  getJson(str){
    let newstr = str.replace(/=/g,":");
    let arr=newstr.split('&');
    let stringObj= "[{" +arr + "}]";
    let jsonobj=eval("("+stringObj+")");
    return jsonobj
  }

  getCookie(name){
    let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
    if (arr = document.cookie.match(reg)) return unescape(arr[2])
    else return null
  }

  showModal = key => (e) => {
    // e.preventDefault(); // 修复 Android 上点击穿透
    this.setState({
        [key]: true,
    });
  }

  onClose = key => () => {
      this.setState({
        [key]: false,
      });
      if(this.state.address.length !== 0) {
        window.location = this.state.address
      }
  }

  async componentDidMount() {
    let token = this.getCookie('_token')
    let pattern=/{i:\d+;s:\d+:"_token";i:\d+;s:\d+:"(.+?)";}/
    token = pattern.exec(decodeURIComponent(token))
    token = token?`${token[1]}`: ''
    console.log(window.location, 'didMount')
    
    let callBack = window.location.href.includes('orderNo') || window.location.href.includes('BizToken')? window.location.href: ''
    let origin = callBack.slice(0, callBack.indexOf("?"))
    this.setState(() => { return {address: origin}})
    callBack = callBack.slice(callBack.indexOf("?"))
        
    var obj = {}; 
    if(callBack.length !== 0) {
        callBack.replace(/([^?=&]+)=([^?=&]+)/g, function () { 
           obj[arguments[1]] = arguments[2]; 
        });
        await axios({
            method: 'get',
            url: userApi.secondIdentifyCallback + callBack,
            headers: {
                'Authorization': `${token}`
             }
            // params: {  'orderNo': obj.orderNo,
            //     'signature': obj.signature,
            //     'code': obj.code,
            //     'newSignature': obj.newSignature,
            //     'h5faceId': obj.h5faceId,
            //     'liveRate': obj.liveRate
            // }
        }).then(response => {
            console.log(response)
            if (response!==undefined && ((response.status === 200 || response.status === 304 || response.status === 400))) {
              if(response.data.data.status !== undefined && response.data.data.status == 1 ){
                // response.data.data !== undefined && response.data.data.length > 0
                this.showModal('modalSuccess')()
              }else {
                this.showModal('modalError')()
              }
          }
        }).catch(err => {
            console.log(err)
            this.showModal('modalError')()
        })
    }
  }

  render(){
    const {info,resource,courseinfo,getCourseInfo, finishedListLock,
      recordCreate, finishedList, finishedPeriod, user_id, pop} = this.props;
    let path = '';let title='';
    if(resource.size!=0&&resource.length!=0){
       path = resource.get('path')
    }
    if(courseinfo.size!=0&&courseinfo.length!=0){
      title = courseinfo.get('title')
    }else{
      getCourseInfo(this.state.courseid)
      title = courseinfo.get('title')
    }

    return (
      <div>
        <Header title = {title}/>
        <div className="container labinfo">
          {path ? <Video path={path} key={Math.random()}
          recordCreate={recordCreate} userid = {this.state.user_id}  pop={pop}
          finishedList={finishedList} finishedPeriod={finishedPeriod} 
          courseid={this.state.courseid} sid={this.state.sid}/>: null}
          <div className="video-title">
            <span>{info.get('title')?info.get('title'):'暂无'}</span>
          </div>
          <VideoTab finishedList={finishedList} finishedListLock={finishedListLock} courseinfo={courseinfo} courseid={this.state.courseid} sid={this.state.sid}/>
        </div>
        <Modal
          visible={this.state.modalError}
          transparent
          maskClosable={false}
          title="人脸身份认证"
          style={{ position: 'sticky'}}>
              <div style={{ height: '90%', overflow: 'scroll' }}>
                  <div className="condition">
                      <img src={require('./img/error.png')} className="error-img margin"></img>
                      <span className="co-des-title margin">认证失败</span>
                      <span className="co-tips-text margin">人脸身份认证未及时响应，本次认证失败</span>
                      <button className="submit-return" onClick={this.onClose('modalError')}>返回</button>
                  </div>
              </div>
          </Modal>
          <Modal
          visible={this.state.modalSuccess}
          transparent
          maskClosable={false}
          title="人脸身份认证"
          style={{ position: 'sticky'}}>
              <div style={{ height: '90%', overflow: 'scroll' }}>
                  <div className="condition">
                      <img src={require('./img/success.png')} className="error-img margin"></img>
                      <span className="co-des-title margin">认证成功</span>
                      <button className="submit-return" onClick={this.onClose('modalSuccess')}>返回</button>
                  </div>
              </div>
          </Modal>
      </div>
    )
  }
}


const mapState = (state) => ({
  info: state.getIn(['labroomvideo', 'subjectInfo']),
  resource: state.getIn(['labroomvideo', 'resource']),
  courseinfo: state.getIn(['courseproject', 'info']),
  user_id: state.getIn(['home','userinfo', 'user_id']),
  finishedList: state.getIn(['labroomvideo', 'finishedList']),
  finishedListLock: state.getIn(['labroomvideo', 'finishedListLock']),
  finishedPeriod: state.getIn(['labroomvideo', 'finishedPeriod']),
  pop: state.getIn(['labroomvideo', 'pop'])
})

const mapDispatch = (dispatch) => ({
  getSubjectInfo(course_id,sub_id){
      dispatch(actionCreators.getSubjectInfo(course_id,sub_id))
  },
  getQuestionList(course_id){
      dispatch(actionCreators.getQuestionList(course_id))
  },
  getUserQuestionList(course_id){
      dispatch(actionCreators.getUserQuestionList(course_id))
  },
  getOtherQuestionList(course_id){
      dispatch(actionCreators.getOtherQuestionList(course_id))
  },
  getCourseInfo(course_id) {
      dispatch(courseActionCreators.getCourseInfo(course_id))
  },
  recordCreate (data) {
    dispatch(actionCreators.recordCreate(data))
  },
  getFinishedCourse(course_id, user_id) {
    dispatch(actionCreators.getFinishedCourse(course_id, user_id))
  },
  getFinishedCourseLock(course_id, user_id) {
    dispatch(actionCreators.getFinishedCourseLock(course_id, user_id))
  },
  getFinishedPlaytime(course_id, user_id, sub_id){
    dispatch(actionCreators.getFinishedPlaytime(course_id, user_id, sub_id))
}
})
export default connect(mapState, mapDispatch)(LabRoom);
